// MySQL in-buffer CREATE TABLE scanner — surfaces tables declared earlier in
// the same buffer so subsequent statements can reference them and their
// columns even before the schema-bus snapshot has refreshed.
//
// The cross-engine scanning logic lives in `../context/inBufferTables`; this
// wrapper pins the engine to `mysql` and maps the generic `qualifier` segment
// to mysql's `database` term so the resolver's existing call sites are
// unchanged.
//
// Closes goals/autocomplete-coverage mysql scripts 40 / 41 / 44.

import {
  findInBufferCreatedTables as findInBufferCreatedTablesShared,
} from '../context/inBufferTables';

export type InBufferTable = {
  readonly name: string;
  readonly database: string | null;
  readonly isTemporary: boolean;
  readonly columns: ReadonlyArray<{ readonly name: string; readonly dataType: string }>;
};

export function findInBufferCreatedTables(
  source: string,
  cursorOffset: number,
): InBufferTable[] {
  return findInBufferCreatedTablesShared(source, cursorOffset, 'mysql').map((t) => ({
    name: t.name,
    database: t.qualifier,
    isTemporary: t.isTemporary,
    columns: t.columns,
  }));
}
